import { render, staticRenderFns } from "./ReceiptOrder.vue?vue&type=template&id=1bd51b49&scoped=true"
import script from "./ReceiptOrder.vue?vue&type=script&lang=js"
export * from "./ReceiptOrder.vue?vue&type=script&lang=js"
import style0 from "./ReceiptOrder.vue?vue&type=style&index=0&id=1bd51b49&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd51b49",
  null
  
)

export default component.exports